import { Box, styledComponent, Typography, FormControl } from '@hermes/web-components'

export const ButtonContainer = styledComponent(Box)(({ theme }) => ({
  display: 'inline-flex',
  borderTop: `1px solid ${theme.palette.neutral[200]}`,
  width: '100%'
}))

export const RadioLabel = styledComponent(Typography)(() => ({
  fontSize: '12px',
  marginBottom: '10px',
  marginTop: '5px',
  lineHeight: '16px'
}))

export const Subtitle = styledComponent(Typography)(({ theme }) => ({
  textAlign: 'center',
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.neutral[200]}`
}))

export const Delivery = styledComponent(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  padding: '16px',
  borderRadius: '8px',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'space-between',
  svg: {
    maxHeight: '16px'
  }
}))

export const RadioFormControl = styledComponent(FormControl)(() => ({
  width: '100%',
  padding: '16px',
  '.MuiFormGroup-root': {
    width: '100%',
    label: {
      marginLeft: 0,
      gap: '10px',
      fontSize: '14px',
      span: {
        lineHeight: '20px',
        fontWeight: 500
      }
    },
    '.MuiRadio-root': {
      fontSize: '18px'
    }
  }
}))
